import React from "react";
import { connect } from 'react-redux';

import { Row, Col, Button, Card, Container, CardBody, CardHeader } from "reactstrap";
import { ClipLoader } from 'react-spinners';
import { history } from '_helpers';
import { ticketActions } from "_actions"
import TicketReceipt from "views/PurchasedTickets/TicketReceipt";
import TicketsHeader from "components/Headers/TicketsHeader.jsx";
import nyc from "assets/img/img-livenyte/nyc.jpg"
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { config } from "_constants";

class TicketReceiptPage extends React.Component {
    constructor(props) {
        super(props);
        const rawPurchaseID = this.props.match.params.hasOwnProperty('purchaseId') && this.props.match.params.purchaseId
        const purchase_id = parseInt(rawPurchaseID, 10)
        const code = this.props.match.params.hasOwnProperty('code') && this.props.match.params.code
        this.state = {
            receipt: null,
            rawPurchaseID: rawPurchaseID,
            purchase_id: purchase_id,
            code: code,
            // sp_id: props.match.params.id ? reverseNumberFunction(parseInt(props.match.params.id, 10)) :  props.location.state.sp_id, 
        };
        this.getApplePass = this.getApplePass.bind(this)
        this.getApplePassV2 = this.getApplePassV2.bind(this)

    }

    componentDidMount() {
        console.log("Redirect Props", this.props)
        this.handleURL()
    }


    handleURL() {
        const { rawPurchaseID, purchase_id, code } = this.state
        const validQuery = purchase_id && code
        if (validQuery) {
            this.props.dispatch(ticketActions.getTapToPayPurchasedTicketReceipt(purchase_id, code, (success, receipt) => {
                if (success) {
                    this.setState({
                        receipt: receipt,
                    })
                }
            }))
        }
    }
    getApplePass() {
        const { receipt, rawPurchaseID, purchase_id, code } = this.state


        if (receipt && purchase_id) {
            this.props.dispatch(ticketActions.getApplePass(purchase_id, (success, data) => {
                if (success) {
                    console.log("viewAssetInBuffer handler:", data)
                    if (success) {
                        window.open(data.url, '_blank', 'noopener,noreferrer')
                        // window.location.href = data.url;

                    }
                }
            })
            )
        }
    }

    getApplePassV2() {
        const { receipt, rawPurchaseID, purchase_id, code } = this.state

        if (receipt && purchase_id) {
            this.props.dispatch(ticketActions.getApplePassV2(purchase_id, (success, data) => {
                if (success) {
                    console.log("viewAssetInBuffer handler:", data)
                    if (success) {
                        window.open(data.url, '_blank', 'noopener,noreferrer')
                        // window.location.href = data.url;

                    }
                }
            })
            )
        }
    }



    render() {
        const { receipt } = this.state
        const { getPurchasedTicketReceiptRequest } = this.props;
        if (getPurchasedTicketReceiptRequest) {
            return (
                <div className="content">
                    <div className="bg-darkMode py-8">
                        <div className="text-center py-8">
                            <h4 className="text-uppercase ls-1 text-white pb-3">
                                Loading&nbsp;&nbsp;
                            </h4>
                            <div className='sweet-loading'>
                                <ClipLoader
                                    sizeUnit={"px"}
                                    size={45}
                                    color={'#ffffff'}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            );

        }
        const title = "Your tickets are here!"
        const lead = receipt ? `${receipt.quantity}x '${receipt.ticket_name}'` : 'Loading'
        console.log("Receipt", receipt)
        return (
            <>
                {receipt ? (
                    <Helmet>
                        {/* --- PRIVACY / SECURITY --- */}
                        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, nocache" />
                        <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, nocache" />
                        <meta name="bingbot" content="noindex, nofollow, noarchive, nosnippet, nocache" />

                        {/* --- SEO / Title --- */}
                        <title>{`Tickets: ${receipt.event_name}`}</title>
                        <meta name="description" content={receipt.description} />

                        {/* --- Canonical URL --- */}
                        <link
                            rel="canonical"
                            href={`${config.serverUrl}/rcpt/tix/${receipt.purchase_id}`}
                        />

                        {/* --- Open Graph (for iMessage, FB, Slack, Discord, LinkedIn) --- */}
                        <meta property="og:type" content="website" />
                        <meta property="og:title" content={`Tickets: ${receipt.event_name}`} />
                        <meta
                            property="og:description"
                            content={`Your tickets for '${receipt.event_name}' are here.`}
                        />
                        <meta property="og:image" content={receipt.photo} />
                        <meta
                            property="og:url"
                            content={`${config.serverUrl}/rcpt/tix/${receipt.purchase_id}`}
                        />
                        <meta property="og:site_name" content="LiveNyte" />

                        {/* Recommended */}
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta
                            property="og:image:alt"
                            content={`Tickets for ${receipt.event_name}`}
                        />

                        {/* --- Twitter Card --- */}
                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content={`Tickets: ${receipt.event_name}`} />
                        <meta
                            name="twitter:description"
                            content={`Your tickets for '${receipt.event_name}' are here.`}
                        />
                        <meta name="twitter:image" content={receipt.photo} />
                        <meta
                            name="twitter:url"
                            content={`${config.serverUrl}/rcpt/tix/${receipt.purchase_id}`}
                        />
                    </Helmet>
                ) :
                    <Helmet>
                        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, nocache" />
                        <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, nocache" />
                        <meta name="bingbot" content="noindex, nofollow, noarchive, nosnippet, nocache" />
                    </Helmet>}
                {receipt &&
                    <TicketsHeader
                        title={"Your tickets are here!"}
                        lead={receipt ? `${receipt.quantity}x '${receipt.ticket_name}'` : 'Loading'}
                        backgroundImage={receipt ? receipt.photo : nyc}
                        eventID={receipt ? receipt.event_id : null}
                    />
                }
                <section className="py-6 pb-9 bg-darkMode dark-mode">
                    <div className="pb-5 force-dark-mode-table mt--13">
                        {receipt &&
                            <>
                                <Col xs={12} sm={9} md={7} lg={8} xl={7} className="ml-auto mr-auto px-2">
                                    <div className="white-box-shadow">
                                        <Card className=" exampleDarkGlassBlur" >
                                            <CardHeader className="text-center">
                                                {title ? (
                                                    <h1 className="text-white">{title}</h1>
                                                ) : null}
                                                {lead ? (
                                                    <p className="text-lead line-styling text-white">{lead}</p>
                                                ) : null}
                                                {receipt.event_id &&
                                                    <Link
                                                        target="_blank"
                                                        to={{
                                                            pathname: `/e/${receipt.event_id}`,
                                                        }}
                                                    >
                                                        <Button
                                                            color="primary"
                                                            className="bg-gradient-livenyte"

                                                        >
                                                            Go to Event
                                                        </Button>
                                                    </Link>
                                                }
                                            </CardHeader>
                                            <TicketReceipt
                                                getCaseCodes={null}
                                                toggle={null}
                                                ticketReceipt={receipt}
                                                showQRC={true}
                                                pageMode={true}
                                            />
                                        </Card>
                                    </div>

                                </Col>
                            </>
                        }
                    </div>
                </section >
            </>)
    }

}



function mapStateToProps(state) {
    const { ticketsData, fanModeData, } = state;
    const { getPurchasedTicketReceiptRequest, ticketReceipt, } = ticketsData;
    const { fanMode } = fanModeData;

    return {
        getPurchasedTicketReceiptRequest, ticketReceipt,
        fanMode,
    };
}

const connectedTicketReceiptPage = connect(mapStateToProps)(TicketReceiptPage);
export { connectedTicketReceiptPage as TicketReceiptPage }; 